import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as deviceApi from "@/api/device";
import * as resourceApi from "@/api/resource";
import * as loginApi from "@/api/login";

import { storeToken, deleteToken } from '@/utils/auth'

export default new Vuex.Store({
  state: {
    // 主题模式: light或dark
    theme: localStorage.getItem('theme') || 'light',

    // 设备总数
    totalDevice: 1256,
    // 运行机时
    totalRunningHours: 5872,
    // 设备总价值
    totalDeviceValue: 17836,
    // 当日预约数
    dailyReservations: 128,
    // 当月送样检测数
    monthlySamples: 562,
    // 服务用户数量
    servedUsers: 562,

    // 单位
    units: [],

    // 登录的用户信息
    token: '',
    userInfo: {},
  },
  mutations: {
    // 切换主题
    TOGGLE_THEME(state) {
      state.theme = state.theme === 'light' ? 'dark' : 'light'
      localStorage.setItem('theme', state.theme)
      document.documentElement.setAttribute('data-theme', state.theme)
    },
    // 更新设备数据
    UPDATE_DEVICE_DATA(state, data) {
      if (data.totalDevice>=0) state.totalDevice = data.totalDevice
      if (data.totalRunningHours>=0) state.totalRunningHours = data.totalRunningHours
      if (data.totalDeviceValue>=0) state.totalDeviceValue = data.totalDeviceValue
      if (data.dailyReservations>=0) state.dailyReservations = data.dailyReservations
      if (data.monthlySamples>=0) state.monthlySamples = data.monthlySamples
      if (data.servedUsers>=0) state.servedUsers = data.servedUsers
    },
    UPDATE_UNITS(state, data) {
      if (data && data.length>0) state.units = data
    },
    UPDATE_TOKEN(state, data) {
      state.token = data
    },
    UPDATE_USERINFO(state, data) {
      state.userInfo = data
    }
  },
  actions: {
    // 切换主题
    toggleTheme({ commit }) {
      commit('TOGGLE_THEME')
    },
    // 从API获取设备数据
    fetchDeviceData({ commit }) {
      deviceApi.overview().then(res => {
        console.log('fetchDeviceData - res:', res);
        //device_count: 设备总数
        //total_reserve_duration_hours: 设备总运行机时(小时)
        //total_device_value: 设备总价值(万元)
        //today_reserve_count: 当日预约数量
        //service_reserve_count: 送样检测数量
        //reserve_user_count: 服务用户数量
        const data = {
          totalDevice: res.device_count,
          totalRunningHours: res.total_reserve_duration_hours,
          totalDeviceValue: res.total_device_value,
          dailyReservations: res.today_reserve_count,
          monthlySamples: res.service_reserve_count,
          servedUsers: res.reserve_user_count,
        }
        commit('UPDATE_DEVICE_DATA', data)
      })
    },
    fetchUnits({ commit }) {
      resourceApi.unit_list().then(res => {
        console.log('fetchUnits - res:', res);
        commit('UPDATE_UNITS', res)
      })
    },
    loginByUsername({ commit }, params) {
      return new Promise((resolve, reject) => {
        loginApi.login_by_username(params).then(res => {
          console.log('loginByUsername - res:', res);
          let token = res.token
          storeToken(token)
          commit('UPDATE_TOKEN', token)
          commit('UPDATE_USERINFO', res)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    setAndStoreToken({ commit }, token) {
      storeToken(token)
      commit('UPDATE_TOKEN', token)
    },
    removeToken({ commit }) {
      deleteToken()
      commit('UPDATE_TOKEN', '')
    },
    setToken({ commit }, token) {
      commit('UPDATE_TOKEN', token)
    },
    fetchUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        loginApi.get_userinfo().then(res => {
          console.log('fetchUserInfo - res:', res);
          commit('UPDATE_USERINFO', res)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    logout({ commit }) {
      deleteToken()
      commit('UPDATE_TOKEN', '')
      commit('UPDATE_USERINFO', {})
    },

  },
  getters: {
    getTheme: state => state.theme,
    getDeviceStats: state => {
      return {
        totalDevice: state.totalDevice,
        totalRunningHours: state.totalRunningHours,
        totalDeviceValue: state.totalDeviceValue,
        dailyReservations: state.dailyReservations,
        monthlySamples: state.monthlySamples,
        servedUsers: state.servedUsers
      }
    },
    getUnits: state => {
      return state.units
    },
    getToken: state => {
      return state.token
    },
    getUserInfo: state => {
      return state.userInfo
    },
    hasUserInfo: state => {
      return !!state.userInfo.user_id
    },
  }
}) 